<template>
  <div class="not-found">
    <v-row justify="center" align="center" class="fill-height">
      <v-card color="transparent" flat class="text-center" max-width="50vw">

        <div class="display-3 grey--text text--darken-2">Page not found.</div>

        <div class="grey--text my-5">
          <span>Sorry, we can't seem to find the page you're looking for. It might have been removed, had its name changed or is temporarily unavailable.</span>
        </div>

        <v-row justify="center">
          <router-link to="/">
            <base-button
              name="Go to home page"
              x-large
            ></base-button>
          </router-link>
        </v-row>
      </v-card>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: "NotFound"
  }
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.not-found {
  height: 700px;
  background: $gray3;
}
</style>